module.exports = ".carousel-caption h4 {\n    color: #d6e5ff;\n}"